const normalizeUrl = (url) => (url.endsWith('/') ? url : `${url}/`)

const resolveApiRoot = () => {
  const envUrl = import.meta.env.VITE_API_URL

  if (envUrl) {
    return normalizeUrl(envUrl)
  }

  if (typeof window !== 'undefined' && window.API_URL) {
    return normalizeUrl(window.API_URL)
  }

}

export const API_ROOT_URL = resolveApiRoot()
export const API_BASE_URL = `${API_ROOT_URL}api/`

